import apiClient from "./apiClient";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;
const BASE_URL_LMS = `${BASE_URL}/api/v1/lms`;
const UPLOAD_TIMESHEET_XLSX_URL = `${BASE_URL_LMS}/upload/xlsx`;
const GET_QUEUE_URL = `${BASE_URL_LMS}/queue`;
const GET_QUEUE_PRE_CALCULATION_AMOUNT_URL = `${BASE_URL}/api/v1/rabbit/queue/pre/calculation`;
const UPDATE_FUNDING_STATUS = `${BASE_URL}/api/v1/kindergarten/lmsSystem/changeFundingStatus`

export async function uploadTimesheetXlsx(formData: FormData, timesheetTypeCode: number, accountingMonth: number, accountingYear: number) {
    try {
        const response = await apiClient.post(
            `${UPLOAD_TIMESHEET_XLSX_URL}?accountingMonth=${accountingMonth}&accountingYear=${accountingYear}&timesheetType=${timesheetTypeCode}`,
            formData,
            {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((response) => {
            return response;
        }).catch((error) => {
            return Promise.reject(error);
        });
        return response.data;
    } catch (error) {
        console.log("error on uploading file: ", error);
        throw error;
    }
}

export async function getTimesheetUploadingQueue(): Promise<number> {
    try {
        const response = await apiClient.get<number>(GET_QUEUE_URL);
        return response.data;
    } catch (error) {
        console.log("error on getting queue: ", error);
        throw error;
    }
}

export async function getPreCalculationAmountRabbitQueue(): Promise<number> {
    try {
        const response = await apiClient.get<number>(GET_QUEUE_PRE_CALCULATION_AMOUNT_URL);
        return response.data;
    } catch (error) {
        console.log("error on getting queue: ", error);
        throw error;
    }
}

export async function updateLmsSystemFundingStatus(lmsSystemId: number | undefined, fundingStatus: string) {
    try {
        const response = await apiClient.post(`${UPDATE_FUNDING_STATUS}/${lmsSystemId}/${fundingStatus}`);
        return response.data;
    } catch (error) {
        console.log("error on getting pre calculation list", error);
        throw error;
    }
}
